/* This file is autogenerated, see readme.md for instructions */
import LoaderSvgIcon from '@bloomreach/banana-theme/icons/loader.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const LoaderIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <LoaderSvgIcon />
    </Icon>
  );
});

LoaderIcon.displayName = 'LoaderIcon';

export default LoaderIcon;
